import React, { useContext } from 'react';
import { IPropertyChild, getChildValueAsArray } from 'components/property-editors/utils/ProviderNodeUtils';
import { IEditorProps } from './Editor';
import { EditorTextArea } from './EditorTextArea';
import { submitStringArrayValue } from '@decisions/server/DecisionsFramework/Design/Properties/PropertyEditorService';
import { PropertyEditorContext } from 'components/property-editors/contexts/PropertyEditorContext';
import { AwaitableContext } from 'contexts/AwaitableContext';

interface IEditorStringArrayFieldProps extends IEditorProps {}

const splitValueToLines = (child: IPropertyChild) => {
  return getChildValueAsArray(child).join('\n');
};

/**
 * Editor which emits a list of string values from a text field.
 *
 * Copyright (c) 2019 Decisions ALl Rights Reserved
 */
export function EditorStringArrayField(props: IEditorStringArrayFieldProps) {
  const { editingContextId, refreshContext } = useContext(PropertyEditorContext);
  const { addPromise, removePromise } = useContext(AwaitableContext);

  const onChange = async (value: string, path: string[]) => {
    // normal setValue works for this, but not inside of a list mapping.
    const selectedElements = value && value.trim() ? value.split('\n') : [];
    const id = path.join(',');
    addPromise(
      id,
      (async () => {
        try {
          await submitStringArrayValue({ editingContext: editingContextId, path, selectedElements });
          refreshContext(); // should this be triggering a full refresh?
          removePromise(id);
        } catch (error) {
          console.error('Failed to save value for', props.path.join(', '));
        }
      })()
    );
  };

  return <EditorTextArea {...props} valueGetter={splitValueToLines} onChange={onChange} />;
}
